
// export default function gaoMap () { // <-- 原作者这里使用的是module.exports
//   return new Promise((resolve, reject) => {
//     if (window.AMap) {
//       resolve(window.AMap)
//     } else {
//       window.initAMap = () => {
//         resolve(window.AMap)
//       }
//     }
//     var script = document.createElement('script')
//     script.type = 'text/javascript'
//     script.charset = 'utf-8'
//     // script.async = true
//     // 1.4.15  ---- 2.0
//     script.src = 'http://webapi.amap.com/maps?v=1.4.15&callback=initAMap&key=09fe221c79834fe378c1465771c38428'
//     script.onerror = reject
//     document.head.appendChild(script)
//     // document.body.appendChild(script)
//   })
// }
/*
 * 异步创建script标签
 */
export default function MapLoader (key) {
  return new Promise((resolve, reject) => {
    if (window.AMap) {
      resolve(window.AMap)
    } else {
      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src = 'https://webapi.amap.com/maps?v=1.4.15&callback=initAMap&key=09fe221c79834fe378c1465771c38428&plugin=AMap.DistrictSearch'
      script.onerror = reject
      document.head.appendChild(script)
    }
    window.initAMap = () => {
      resolve(window.AMap)
    }
  })
}
